module.exports = __webpack_public_path__ + "img/icon-implantation-13.2498bd07.svg";